// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> birchwood-homes
// Generated: 2026-11-02T18:11:18.976Z
// Counts: 0 design, 31 content, 15 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Flexible Floor Plans for Your Lifestyle</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Spacious Apartments in Fairbanks</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Embrace Fairbanks Living</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to Birchwood</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from thoughtfully designed three-, four-, and five-bedroom homes in Fairbanks, AK.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience comfort and a true sense of community in the heart of Fairbanks, AK.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking for apartments for rent in Fairbanks, AK? Birchwood offers modern living in the Hamilton Acres neighborhood, close to downtown and top employers like Fort Wainwright. Enjoy spacious layouts and useful on-site amenities, including options for furnished homes. Our pet-friendly community welcomes you into a relaxed, neighborly atmosphere where convenience and comfort come standard.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a037a1-3bc4-72cb-9e6a-6b1d3744d1df.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sofa, armchair, coffee table, and artwork."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a037a1-3fb2-7228-8d2d-36d322a83254.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Dining room and living room area with furniture, view into kitchen."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-4081-767f-8f72-7dc9e3248ee2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen and dining area with a table set for four."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-4483-7733-9205-f3d60778c052.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a king-size bed, dresser, and closet."
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a037a1-3fa9-71ee-8a12-5fa25d26b376.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior view of an apartment showing a dining area with a table and chairs, leading to a living room."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-35d9-7497-96fd-0c73409e03dd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sofa, armchair, coffee table, and lamps."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/019d021c-639b-70aa-bb1b-0fddbd3aee19.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Green Birchwood townhome building with attached garage and green lawn in Fairbanks, AK"
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a037a1-3c9f-7652-9fd6-da320ec76058.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with white cabinets, stainless steel appliances including a refrigerator and stove, and a double sink."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a037a1-55fa-744b-92c6-3fee7215bcb4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bedroom with a queen-size bed, nightstands, and a closet."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167175/01a037a1-3bc4-72cb-9e6a-6b1d3744d1df.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sofa, armchair, coffee table, and artwork."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
